import { useState } from 'react';
import { Flex, FlexProps, HStack, Icon, IconName, Spinner } from '../../atoms';
import { Button } from '../../atoms/forms/button/button';

type Props = {
  pageCount: number;
  currentPage: number;
  onPageChange: (newPage: number) => void;
} & Pick<FlexProps, 'justifyContent'>;

export function PageChanger({
  pageCount,
  currentPage,
  onPageChange,
  justifyContent = 'end'
}: Props): JSX.Element | null {
  const [switchingPage, setSwitchingPage] = useState(false);
  return (
    <HStack justifyContent={justifyContent}>
      {currentPage > 0 && pageCount > 1 && switchingPage === false && (
        <Button
          type="button"
          variant="tertiary"
          leftIcon={<Icon h="22px" w="22px" name={IconName.ArrowLeft} />}
          onClick={(): void => {
            setSwitchingPage(true);
            onPageChange(currentPage - 1);
            setSwitchingPage(false);
          }}
        >
          Previous
        </Button>
      )}
      {currentPage < pageCount - 1 && switchingPage === false && (
        <Button
          type="button"
          variant="tertiary"
          rightIcon={<Icon h="22px" w="22px" name={IconName.ArrowRight} />}
          onClick={(): void => {
            setSwitchingPage(true);
            onPageChange(currentPage + 1);
            setSwitchingPage(false);
          }}
        >
          Next
        </Button>
      )}
      {switchingPage === true && (
        <Flex h="36px" alignItems="center" padding="0 20px">
          <Spinner role="status" color="blue" />
        </Flex>
      )}
    </HStack>
  );
}
